export default __webpack_public_path__ + "static/media/Main-Graphic.2147fe6b.png";